import { render } from "./ModalDetailBugdet.vue?vue&type=template&id=c1e60436"
import script from "./ModalDetailBugdet.vue?vue&type=script&lang=js"
export * from "./ModalDetailBugdet.vue?vue&type=script&lang=js"

import "./ModalDetailBugdet.vue?vue&type=style&index=0&id=c1e60436&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__